import { IAuthState, IAuthAction, SIGN_IN, SIGN_OUT } from "./types";

const initialState: IAuthState = {
  ready: false,
  isAuthenticated: false,
};

export function authReducer(state: IAuthState = initialState, action: IAuthAction): IAuthState {
  switch (action.type) {
    case SIGN_IN:
    case SIGN_OUT:
      return action.payload;
  }
  return state;
}
